import {Footnotes, InlineLink} from '@primer/react-brand'

export default function FootnotesSection() {
  return (
    <Footnotes>
      <Footnotes.Item>
        The Total Economic Impact™ Of GitHub Enterprise Cloud and Advanced Security, a commissioned study conducted by
        Forrester Consulting, 2022. Results are for a composite organization based on interviewed customers.
      </Footnotes.Item>

      <Footnotes.Item>GitHub, Octoverse 2022 The state of open source software.</Footnotes.Item>

      <Footnotes.Item>
        Currently only available in the EU, with additional regions coming soon. Contact Sales to learn how you can
        provision GitHub Enterprise Cloud with data residency. Have more questions on data residency? Learn more at our{' '}
        <InlineLink href="https://docs.github.com/en/enterprise-cloud@latest/early-access/admin/data-residency-for-github-enterprise-cloud">
          docs
        </InlineLink>
        .
      </Footnotes.Item>

      <Footnotes.Item>
        Customers who configure GitHub Enterprise Cloud with data residency will have their own unique namespace on
        ghe.com isolated from the open-source cloud on github.com and hosted on Azure. Learn more about GitHub
        Enterprise Cloud with data residency at our{' '}
        <InlineLink href="https://docs.github.com/en/enterprise-cloud@latest/early-access/admin/data-residency-for-github-enterprise-cloud">
          docs
        </InlineLink>
        .
      </Footnotes.Item>
    </Footnotes>
  )
}

try{ FootnotesSection.displayName ||= 'FootnotesSection' } catch {}